var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    {
      'subscriber-avatar__sm': _vm.small,
      'subscriber-avatar__xs': _vm.xSmall,
      '--with-profile': _vm.withProfile
    },
    'subscriber-avatar'
  ],style:({ fontSize: _vm.fontSize }),on:{"click":_vm.openProfile}},[(_vm.isLoading)?_c('div',{staticClass:"subscriber-avatar__loading"},[_c('v-loader')],1):_vm._e(),(_vm.imageUrl)?_c('div',{staticClass:"subscriber-avatar__image",style:({
      backgroundImage: ("url(" + _vm.imageUrl + ")")
    })}):_c('span',{staticClass:"subscriber-avatar__initials rounded-circle",attrs:{"title":_vm.text}},[_vm._v(" "+_vm._s(_vm.initials)+" ")]),(_vm.withProfile && _vm.subscriber && _vm.subscriber.user_id && _vm.isProfileOpen)?_c('member-profile-modal',{attrs:{"user-id":_vm.subscriber.user_id},on:{"open":function () { return (_vm.isProfileOpen = true); },"close":function () { return (_vm.isProfileOpen = false); }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }